import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Col, Row, Steps } from 'antd';
import { isUserMultiTenant } from "../../../../../swzutils/UserPermissionsUtil";
import ImportFormatStep from './ImportFormatStep';
import UploadFileStep from './UploadFileStep';
import PreviewStep from './PreviewStep';
import CompletedStep from './CompletedStep';
import API from "../../../../../API";
import { ImportFormatEnum } from "../../../api/Representation";
import RequireTenantSelection from "../../../components/RequireTenantSelection";
import { useAppSelector } from "../../../../../store";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../../store/slice/auth";
const steps = [{
        title: 'Import Type',
        description: 'Select import file type',
    }, {
        title: 'Upload File',
        description: 'Select or drop upload file',
    }, {
        title: 'Preview',
        description: 'Preview imported content',
    }, {
        title: 'Completed',
        description: 'Import is complete',
    }];
const ConsignmentImportWizard = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [importFile, setImportFile] = useState(null);
    const [importFormat, setImportFormat] = useState(ImportFormatEnum.CONSIGNMENT_LINES);
    const [uploadUri, setUploadUri] = useState(`${API.origin()}/admin/v1/consignments/imports?format=${importFormat}`);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const back = () => {
        step(-1);
    };
    const step = (direction) => {
        let nextStep = currentStep + direction;
        nextStep = Math.max(0, nextStep);
        nextStep = Math.min(steps.length - 1, nextStep);
        setCurrentStep(nextStep);
    };
    const importFormatStepComplete = (importFormat) => {
        const importsBaseUri = `${API.origin()}/admin/v1/consignments/imports?format=${importFormat}`;
        const uploadUri = isUserMultiTenant(loggedInUser) ? `${importsBaseUri}&tenantId=${selectedTenant.id}` : importsBaseUri;
        setUploadUri(uploadUri);
        setImportFormat(importFormat);
        step(+1);
    };
    const uploadStepComplete = (impFile) => {
        setImportFile(impFile);
        step(+1);
    };
    const previewStepComplete = () => {
        step(+1);
    };
    const restart = () => {
        setCurrentStep(0);
        setImportFile(null);
    };
    return (_jsxs(RequireTenantSelection, { children: [_jsx(Row, { children: _jsx(Col, { xs: { span: 22, offset: 1 }, children: _jsx(Steps, { current: currentStep, items: steps }) }) }), _jsx("p", { children: "\u00A0" }), _jsx(ImportFormatStep, { active: currentStep === 0, importFormat: importFormat, onComplete: importFormatStepComplete }), _jsx(UploadFileStep, { active: currentStep === 1, uploadUri: uploadUri, importFormat: importFormat, onBack: back, onComplete: uploadStepComplete }), importFile &&
                _jsx(PreviewStep, { active: currentStep === 2, importFile: importFile, onBack: back, onComplete: previewStepComplete }), _jsx(CompletedStep, { active: currentStep === 3, onDoAgain: restart })] }));
};
export default ConsignmentImportWizard;
